import PropTypes from 'prop-types';

// Read guard for Overview tab
// Currently open to all users - add permission check later if needed
export const OverviewReadGuard = ({ children }) => {
    // TODO: Add permission check when ready
    // const { member_permission = {} } = useSelector((state) => state.account)
    // const isReadAllowed = member_permission["overview_is_view_overview"]
    // return isReadAllowed ? children : <NoPermissionPage />

    return children;
};

OverviewReadGuard.propTypes = {
    children: PropTypes.node
};
